import { DropdownMenuItem } from "@gigpro/ui/DropdownMenu";
import { cn } from "@gigpro/ui/tailwind/cn";
import { Link } from "@tanstack/react-router";
import type { NavItemButton, NavItemLink } from "layouts/BaseLayout/types";
import { useNavLinkProps } from "layouts/BaseLayout/utils";
import type React from "react";

type DropdownNavItemProps = {
  item: NavItemLink | NavItemButton;
  onClick?: () => void;
  className?: string;
};

const iconWrapperClassNames = cn("text-brand [&>*:first-child]:mr-2 [&>*:first-child]:size-4");
const commonItemClassNames = cn(
  "flex flex-row items-center justify-start px-3 py-2 text-large font-regular whitespace-nowrap text-black",
);

export const DropdownNavItem: React.FC<DropdownNavItemProps> = ({ item, onClick, className }) => {
  const navLinkProps = useNavLinkProps();
  if (item.type === "link") {
    const { title, icon, external } = item;
    return (
      <DropdownMenuItem key={title} className={cn(commonItemClassNames, "transition-colors", className)} asChild>
        <Link {...navLinkProps(item)} target={external ? "_blank" : "_self"} onClick={onClick}>
          <span className={iconWrapperClassNames}>{icon}</span>
          {title}
          {item.isBeta ? (
            <span className="ml-0.5 rounded-xl bg-tags-green px-2 text-small text-black">Beta</span>
          ) : null}
        </Link>
      </DropdownMenuItem>
    );
  }
  if (item.type === "button") {
    return (
      <DropdownMenuItem
        key={item.title}
        onClick={() => {
          item.onClick();
          onClick?.();
        }}
        className={cn(commonItemClassNames, className)}
      >
        <span className={iconWrapperClassNames}>{item.icon}</span>
        {item.title}
      </DropdownMenuItem>
    );
  }
};
